<template>
  <v-avatar color="#C4C4C4" size="31">
    <v-icon color="grey">mdi-account</v-icon>
  </v-avatar>
</template>

<script>
export default {
  name: 'NoAvatar'
}
</script>
